<template>
  <transition name="fade">
    <div
      v-if="$f.isSearchShown"
      class="global-search"
    >
      <div
        class="overlay"
        @click.self="$f.toggleSearch"
      >
        <search-form />
      </div>
    </div>
  </transition>
</template>

<script>

/* Icons */
import searchForm from './search-form.vue';

export default {
  name: 'GlobalSearch',
  components: { searchForm },

  data() {
    return {
      query: ''
    }
  },
};
</script>

<style lang="scss">
.global-search {
  display: none;
}

@include breakpoint("tablet") {
  //
}

@include breakpoint("desktop") {
  .global-search {
    display: block;

    .overlay {
      z-index: 1000;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      background-color: rgba($black, .64);
    }

    .search-form {
      position: absolute;
      top: 50%;
      left: calc(50% - 404px);
      width: 808px;
      box-shadow: 0 4px 32px rgba(0, 0, 0, .08);
    }
  }
}
</style>